// extracted by mini-css-extract-plugin
export default {"title":"Contact_title__TCqNu","form":"Contact_form__I9QZJ","btn":"Contact_btn__HgEF4"};